module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-atlasObscura.fea07c0cee36b47a9a0cf376e595403d.png";